import { resourcePath } from '@gameday/utils/resource-path';
let DFVOverrideId;

const buildFieldViewStream = ({
    venueId,
    useDVR = false,
    gamePk
}) => {
    if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
        const params = new URLSearchParams(location.search);
        const DFVOverride = params.get('DFVOverride');
        if (DFVOverride !== null && !isNaN(DFVOverride) && !DFVOverrideId) {
            DFVOverrideId = DFVOverride;
        }
    }

    const streamURL = !useDVR ? resourcePath.get('dynamicFieldView', { venueId: DFVOverrideId ?? venueId, gamePk }) : resourcePath.get('dynamicFieldViewDVR', { venueId: DFVOverrideId ?? venueId, gamePk });

    return {
        id: `dynamic-field-view-${venueId}-stream`,
        url: streamURL // 'https://devstreaming-cdn.apple.com/videos/streaming/examples/bipbop_16x9/bipbop_16x9_variant.m3u8'
    };
};

export default buildFieldViewStream;
